<scaffold-dialog [title]="'file_upload'|translation" [size]="'half'">
  <div scaffoldDialogBody>
    <div class="container" appFileDrop (fileDropped)="onFileDropped($event)">
      <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
      <nb-icon status="primary" pack="fas" icon="cloud-upload-alt" style="font-size: 5rem;"></nb-icon>
        <div class="upload-label">{{'drag_and_drop_file'| translation}}</div>
        <div class="upload-label">{{'or'| translation}}<span class="fake-link">{{'browse'| translation}}</span></div> 
    </div>
    <div class="files-list">
      <div class="single-file" *ngFor="let file of files; let i = index">
        <div class="file-icon">
          <span [ngSwitch]="file.type">
            <nb-icon *ngSwitchCase="'image/jpeg'" pack="fas" icon="image">
            </nb-icon>
            <nb-icon *ngSwitchCase="'image/gif'" pack="fas" icon="image">
            </nb-icon>
            <nb-icon *ngSwitchCase="'image/png'" pack="fas" icon="image">
            </nb-icon>
            <nb-icon *ngSwitchCase="'application/x-zip-compressed'" pack="fas" icon="file-archive">
            </nb-icon>
            <nb-icon *ngSwitchCase="'application/pdf'" pack="fas" icon="file-pdf">
            </nb-icon>
            <nb-icon *ngSwitchDefault pack="fas" icon="file">
            </nb-icon>
          </span>
        </div>
        <div class="info">
          <h4 class="name">
            {{ file?.name }}
          </h4>
          <p class="size">
            {{ formatBytes(file?.size) }}
          </p>
          <nb-progress-bar mode="determinate" status="primary" [value]="file?.progress" [displayValue]="true"></nb-progress-bar>
          <p *ngIf="file?.error">{{file?.error}}</p>
        </div>
        <div>
          <button nbButton ghost (click)="deleteFile(i)" [nbTooltip]="'upload_complete_click_to_hide'|translation" aria-label="Hide Upload" *ngIf="file?.progress==100 || file?.error">
            <nb-icon status="info" pack="fas" icon="check">
            </nb-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <button nbButton status="secondary" (click)="close()">{{'done_uploading'| translation}}</button>
  </div>
</scaffold-dialog>
